const EMAIL_REGEX = new RegExp(/[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/);

const checkValidity = (email) => EMAIL_REGEX.test(email);

export {
  EMAIL_REGEX,
  checkValidity,
};
